__turbopack_context__.v({
  "eyebrow": "eyebrow-module-scss-module__k1-ksW__eyebrow",
});
